import styled from 'styled-components'

export const FilterRow = styled.div`
    padding-inline: var(--__huma-component-modal-content-padding);
`
